import { atom } from 'jotai';

/**
 * One-shot request to show the Get started checklist expanded, even if it was
 * folded or closed earlier. Bumped by a landing that asks the clinician to try
 * an agent task; the checklist host consumes it and resets it to 0.
 */
export const heidi2GetStartedChecklistRevealAtom = atom(0);
